"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputMaskControlledProps = exports.default = exports.MaskUtils = void 0;
var _react = _interopRequireWildcard(require("react"));
var _childrenWrapper = require("./children-wrapper");
var _constants = require("./constants");
var _hooks = require("./hooks");
var _defer = require("./utils/defer");
var _helpers = require("./utils/helpers");
var _input = require("./utils/input");
var _mask = _interopRequireDefault(require("./utils/mask"));
var _validateProps = require("./validate-props");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MaskUtils = exports.MaskUtils = _mask.default;
const inputMaskControlledProps = exports.inputMaskControlledProps = _constants.CONTROLLED_PROPS;
const InputMask = /*#__PURE__*/(0, _react.forwardRef)((props, externalRef) => {
  const {
    alwaysShowMask,
    beforeMaskedStateChange,
    children,
    formatChars,
    mask,
    maskPlaceholder,
    ...restProps
  } = props;
  (0, _validateProps.validateMaxLength)(props);
  (0, _validateProps.validateMaskPlaceholder)(props);
  const maskUtils = (0, _react.useMemo)(() => new MaskUtils({
    formatChars,
    mask,
    maskPlaceholder
  }), [formatChars, mask, maskPlaceholder]);
  const isMasked = !!mask;
  const isEditable = !restProps.disabled && !restProps.readOnly;
  const isControlled = props.value !== null && props.value !== undefined;
  const previousIsMasked = (0, _hooks.usePrevious)(isMasked);
  const propsValue = (0, _helpers.toString)(props.value);
  const initialValue = isControlled ? propsValue : (0, _helpers.toString)(props.defaultValue) || '';
  const {
    inputRef,
    getInputState,
    setInputState,
    getLastInputState
  } = (0, _hooks.useInputState)(initialValue, isMasked);
  const getInputElement = (0, _hooks.useInputElement)(inputRef);
  function onChange(event) {
    const currentState = getInputState();
    const previousState = getLastInputState();
    let newInputState = maskUtils.processChange(currentState, previousState);
    if (beforeMaskedStateChange) {
      newInputState = beforeMaskedStateChange({
        currentState,
        previousState,
        nextState: newInputState
      });
    }
    setInputState(newInputState);
    if (props.onChange) {
      props.onChange(event);
    }
  }
  function onFocus(event) {
    // If autoFocus property is set, focus event fires before the ref handler gets called
    inputRef.current = event.target;
    const currentValue = getInputState().value;
    if (isMasked && currentValue !== '' && !maskUtils.isValueFilled(currentValue)) {
      let newValue = maskUtils.formatValue(currentValue);
      let newSelection = maskUtils.getDefaultSelectionForValue(newValue);
      let newInputState = {
        value: newValue,
        selection: newSelection
      };
      if (beforeMaskedStateChange) {
        newInputState = beforeMaskedStateChange({
          currentState: getInputState(),
          previousState: getLastInputState(),
          nextState: newInputState
        });
        newValue = newInputState.value;
        newSelection = newInputState.selection;
      }
      setInputState(newInputState);
      if (newValue !== currentValue && props.onChange) {
        props.onChange(event);
      }

      // Chrome resets selection after focus event,
      // so we want to restore it later
      (0, _defer.defer)(() => {
        setInputState(getLastInputState());
      });
    }
    if (props.onFocus) {
      props.onFocus(event);
    }
  }
  function onBlur(event) {
    const currentValue = getInputState().value;
    const lastValue = getLastInputState().value;
    if (isMasked && !alwaysShowMask && maskUtils.isValueEmpty(lastValue)) {
      let newValue = '';
      let newInputState = {
        value: newValue,
        selection: {
          start: 0,
          end: 0,
          length: 0
        }
      };
      if (beforeMaskedStateChange) {
        newInputState = beforeMaskedStateChange({
          currentState: getInputState(),
          previousState: getLastInputState(),
          nextState: newInputState
        });
        newValue = newInputState.value;
      }
      setInputState(newInputState);
      if (newValue !== currentValue && props.onChange) {
        props.onChange(event);
      }
    }
    if (props.onBlur) {
      props.onBlur(event);
    }
  }

  // Tiny unintentional mouse movements can break cursor
  // position on focus, so we have to restore it in that case
  //
  // https://github.com/sanniassin/react-input-mask/issues/108
  function onMouseDown(event) {
    const input = getInputElement();
    const {
      value
    } = getInputState();
    const inputDocument = (0, _helpers.getElementDocument)(input);
    if (inputDocument && !(0, _input.isInputFocused)(input) && !maskUtils.isValueFilled(value)) {
      const mouseDownX = event.clientX;
      const mouseDownY = event.clientY;
      const mouseDownTime = new Date().getTime();
      const mouseUpHandler = mouseUpEvent => {
        // @ts-ignore
        inputDocument.removeEventListener('mouseup', mouseUpHandler);
        if (!(0, _input.isInputFocused)(input)) {
          return;
        }
        const deltaX = Math.abs(mouseUpEvent.clientX - mouseDownX);
        const deltaY = Math.abs(mouseUpEvent.clientY - mouseDownY);
        const axisDelta = Math.max(deltaX, deltaY);
        const timeDelta = new Date().getTime() - mouseDownTime;
        if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
          const lastState = getLastInputState();
          const newSelection = maskUtils.getDefaultSelectionForValue(lastState.value);
          const newState = {
            ...lastState,
            selection: newSelection
          };
          setInputState(newState);
        }
      };
      // @ts-ignore
      inputDocument.addEventListener('mouseup', mouseUpHandler);
    }
    if (props.onMouseDown) {
      props.onMouseDown(event);
    }
  }

  // For controlled inputs we want to provide properly formatted
  // value prop
  if (isMasked && isControlled) {
    const input = getInputElement();
    const isFocused = input && (0, _input.isInputFocused)(input);
    let newValue = isFocused || alwaysShowMask || propsValue ? maskUtils.formatValue(propsValue) : propsValue;
    if (beforeMaskedStateChange) {
      newValue = beforeMaskedStateChange({
        nextState: {
          value: newValue,
          selection: {
            start: 0,
            end: 0,
            length: 0
          }
        }
      }).value;
    }
    setInputState({
      ...getLastInputState(),
      value: newValue
    });
  }
  const lastState = getLastInputState();
  const lastSelection = lastState.selection;
  const lastValue = lastState.value;
  (0, _react.useLayoutEffect)(() => {
    if (!isMasked) {
      return;
    }
    const input = getInputElement();
    const isFocused = (0, _input.isInputFocused)(input);
    const previousSelection = lastSelection;
    const currentState = getInputState();
    let newInputState = {
      ...currentState
    };
    const currentValue = currentState.value;
    const formattedValue = maskUtils.formatValue(currentValue);
    const isValueEmpty = maskUtils.isValueEmpty(formattedValue);

    // Update value for uncontrolled inputs to make sure
    // it's always in sync with mask props
    if (!isControlled) {
      const shouldFormatValue = !isValueEmpty || isFocused || alwaysShowMask;
      if (shouldFormatValue) {
        newInputState.value = formattedValue;
      } else if (isValueEmpty && !isFocused) {
        newInputState.value = '';
      }
    }
    if (isFocused && !previousIsMasked) {
      // Adjust selection if input got masked while being focused
      newInputState.selection = maskUtils.getDefaultSelectionForValue(newInputState.value);
    } else if (isControlled && isFocused) {
      if (isValueEmpty) {
        newInputState.selection = {
          start: 0,
          end: 0,
          length: 0
        };
        // Restore cursor position if value has changed outside change event
      } else if (previousSelection && previousSelection.start !== null && previousSelection.end !== null) {
        newInputState.selection = previousSelection;
      }
    }
    if (beforeMaskedStateChange) {
      newInputState = beforeMaskedStateChange({
        currentState,
        nextState: newInputState
      });
    }
    setInputState(newInputState);
  });
  const inputProps = {
    ...restProps,
    onFocus,
    onBlur,
    onChange: isMasked && isEditable ? onChange : props.onChange,
    onMouseDown: isMasked && isEditable ? onMouseDown : props.onMouseDown,
    ref: (0, _helpers.mergeRefs)(inputRef, externalRef),
    value: isMasked && isControlled ? lastValue : props.value
  };
  if (children) {
    (0, _validateProps.validateChildren)(props, children);
    return (0, _react2.jsx)(_childrenWrapper.ChildrenWrapper, inputProps, children);
  }
  return (0, _react2.jsx)("input", inputProps);
});
InputMask.displayName = 'InputMask';
var _default = exports.default = InputMask;